export type StateOption = {
  value: string;
  label: string;
  code: string;
  name: string;
};

type BuildStateOptionsResult = {
  options: StateOption[];
  defaultValue?: string;
};

function findState(states: readonly StateOption[], value?: string | null) {
  const normalized = value?.trim().toLowerCase();
  if (!normalized) return undefined;

  return states.find(
    (state) =>
      state.value.toLowerCase() === normalized ||
      state.code.toLowerCase() === normalized ||
      state.name.toLowerCase() === normalized,
  );
}

export function buildStateOptions(
  states: readonly StateOption[],
  initialState?: string | null,
): BuildStateOptionsResult {
  const options = states.map((state) => ({ ...state }));
  const trimmed = initialState?.trim();

  if (!trimmed) {
    return { options, defaultValue: undefined };
  }

  const match = findState(options, trimmed);
  if (match) {
    return { options, defaultValue: match.value };
  }

  const custom = {
    value: trimmed,
    label: trimmed,
    code: trimmed,
    name: trimmed,
  };
  return { options: [...options, custom], defaultValue: custom.value };
}

export function getStateLabel(
  states: readonly StateOption[],
  value?: string | null,
): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  return findState(states, trimmed)?.name ?? trimmed;
}
